
import { Component, Vue } from "vue-property-decorator";
import HinaInput from "./baseComponent/hina-input.vue";
import HinaSelect from "./baseComponent/hina-select.vue";
import Dialog from "./Dialog.vue";
import Interview, {
  TableItem,
  ADD,
  EDIT
} from "@/lib/interview-experiment/index";

@Component({
  components: { HinaInput, HinaSelect, Dialog }
})
export default class Index extends Vue {
  type = ADD;
  configId = null; // 任务ID
  taskNameLike = ""; // 任务名称
  originExamId = ""; //原面试ID
  targetExamId = ""; //灰度面试ID
  status = "0"; // 状态
  title = ""; //
  page = 1; // 当前
  total = 0; // 总页数

  // 是否是重新点击搜索，如果筛选条件改变又点击搜索那么需要重新从第一页开始
  features: object | null = null; // 筛选条件上次的结果
  matchListString = "";
  visible = false; // 弹窗的显示与否
  data: object | null = null; // 弹窗中的数据
  options = [
    {
      value: "0",
      label: "生效中"
    },
    {
      value: "1",
      label: "已关闭"
    }
  ];

  tableData: TableItem[] = []; // 表格数据

  transfer(matchList: string[][]): string {
    const _list = matchList.map((ele: Array<string>) => {
      return ele.join("-");
    });
    let str = _list.join("\n");
    return str;
  }

  showModal(): void {
    this.visible = true;
    this.title = "新建面试灰度";
    this.type = ADD;
  }

  search(): void {
    this.getList();
  }

  handleDataUpdate(newData: object | null): void {
    this.data = newData;
  }

  // 映射值
  getStatusList(status: string): number[] {
    const options = {
      "0": [0],
      "1": [1],
      "": [0, 1, 2]
    };
    return options[status];
  }

  setPage(statusList: any[]): void {
    const _features = {
      configId: this.configId,
      taskNameLike: this.taskNameLike,
      originExamId: this.originExamId,
      targetExamId: this.targetExamId,
      statusList: JSON.stringify(statusList)
    };
    if (JSON.stringify(_features) !== JSON.stringify(this.features)) {
      this.page = 1;
    }
  }
  getList(): void {
    // 将上次的筛选条件和这次的做对比，如果一样就不用改变分页，如果不一样就需要改变分页
    const statusList = this.getStatusList(this.status);
    this.setPage(statusList);
    console.log("this.page: ", this.page);
    const params = {
      features: {
        configId: Number(this.configId),
        taskNameLike: this.taskNameLike,
        originExamId: this.originExamId,
        targetExamId: this.targetExamId,
        statusList,
        returnAll: false // 是否返回全量忽略分页
      },
      page: this.page,
      pageSize: 10
    };
    Interview.getList(params).then(res => {
      if (res.data.code === 0) {
        const { list, count } = res.data.data;
        this.total = count;
        this.tableData = list;
        // 把上一次的筛选条件缓存起来
        this.features = {
          configId: this.configId,
          taskNameLike: this.taskNameLike,
          originExamId: this.originExamId,
          targetExamId: this.targetExamId,
          statusList: JSON.stringify(statusList)
        };
      }
    });
  }
  created(): void {
    this.getList();
  }
  edit(item: object): void {
    this.type = EDIT;
    this.title = "面试灰度";
    // 打开弹窗
    this.visible = true;
    this.data = { ...item };
  }

  pageChange(newPage: number): void {
    this.page = newPage;
    this.getList();
  }

  changeStatus(item: TableItem): void {
    const { isClose, configId } = item;
    const params = { configId, isClose: isClose ? 0 : 1 };
    Interview.changeStatus(params)
      .then(res => {
        if (res.data.code === 0) {
          this.getList(); // 重新拉接口
        }
      })
      .catch(error => {
        console.log("error: ", error);
      });
  }
}
